export const STANDARD_RU_CITIES = [
  "Москва",
  "Санкт-Петербург",
  "Архангельск",
  "Астрахань",
  "Барнаул",
  "Белгород",
  "Брянск",
  "Владивосток",
  "Владимир",
  "Волгоград",
  "Вологда",
  "Воронеж",
  "Екатеринбург",
  "Иваново",
  "Ижевск",
  "Иркутск",
  "Казань",
  "Калининград",
  "Калуга",
  "Кемерово",
  "Киров",
  "Кострома",
  "Краснодар",
  "Красноярск",
  "Курган",
  "Курск",
  "Липецк",
  "Магнитогорск",
  "Махачкала",
  "Набережные Челны",
  "Нижний Новгород",
  "Новокузнецк",
  "Новосибирск",
  "Омск",
  "Орёл",
  "Оренбург",
  "Пенза",
  "Пермь",
  "Петрозаводск",
  "Псков",
  "Ростов-на-Дону",
  "Рязань",
  "Самара",
  "Саратов",
  "Севастополь",
  "Сочи",
  "Ставрополь",
  "Сургут",
  "Томск",
  "Тула",
  "Тюмень",
  "Ульяновск",
  "Уфа",
  "Хабаровск",
  "Чебоксары",
  "Челябинск",
  "Череповец",
  "Ярославль",
] as const;

export function buildCitySelectOptions(additionalCities: string[] = []) {
  const baseSet = new Set<string>(STANDARD_RU_CITIES as readonly string[]);
  const extras = Array.from(
    new Set(
      additionalCities
        .map((city) => city.trim())
        .filter((city) => city && !baseSet.has(city)),
    ),
  ).sort((left, right) => left.localeCompare(right, "ru"));

  return [...STANDARD_RU_CITIES, ...extras].map((city) => ({ label: city, value: city }));
}
